import gql from 'graphql-tag';

/**
 * Query to fetch available submission type options for the submission form.
 *
 * @returns List of submission types with their value, product description, price, and sale status
 * @usedIn Submission form to display available submission options
 */
export const SUBMISSION_TYPE_OPTIONS = gql`
  query {
    submissionTypeOptions {
      value
      productDescription
      price
      onSale
    }
  }
`;

/**
 * Query to fetch all submissions for the currently authenticated user.
 *
 * @returns List of user's submissions including order info, status, content details, service info, and associated post
 * @usedIn MySubmissions page layout
 */
export const MY_SUBMISSIONS = gql`
  query {
    mySubmissions {
      submissionId
      orderNumber
      contentTitle
      contentUrl
      contentDescription
      status
      flagged
      createdAt
      submissionType
      order {
        status
        flagged
        amountPaid
      }
      contentImage {
        sourceUrl
        sourceSet
      }
      post {
        title
        slug
      }
      service {
        serviceId
        name
        parent {
          serviceId
          name
        }
        vendorId
        vendor {
          name
        }
      }
      services {
        serviceId
        name
        parent {
          serviceId
          name
        }
        vendorId
        vendor {
          name
        }
      }
    }
  }
`;

/**
 * Query to fetch a specific submission by order number for the currently authenticated user.
 *
 * @param orderNumber - The submission order number (required)
 * @returns Complete submission details including order payment info, credits, service details, and associated post
 * @usedIn Submission detail page
 */
export const MY_SUBMISSION_BY_ORDER_NUMBER = gql`
  query mySubmissionByOrderNumber($orderNumber: String!) {
    mySubmissionByOrderNumber(orderNumber: $orderNumber) {
      submissionId
      orderNumber
      contentTitle
      contentUrl
      contentDescription
      status
      flagged
      createdAt
      submissionType
      terms
      order {
        status
        flagged
        paymentType
        amountPaid
        ccLast4
      }
      contentImage {
        sourceUrl
        sourceSet
      }
      post {
        title
        slug
      }
      credits {
        creditId
        submissionId
        creditType {
          typeName
        }
        name
        user {
          userId
          preferredUsername
          avatar {
            sourceUrl
            sourceSet
          }
        }
        socialMedia {
          type
          link
        }
      }
      service {
        serviceId
        name
        parent {
          serviceId
        }
        vendorId
        vendor {
          name
        }
      }
      services {
        serviceId
        name
        parent {
          serviceId
          name
        }
        vendorId
        vendor {
          name
        }
      }
    }
  }
`;
